import React, { useState } from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FarbRaume } from './FarbRaume';
import { FarbRaum } from './FarbRaum';

const FarbRaumePage = ({ heading, description, images, rooms }) => {
  const [isVisibleRoom, setIsVisibleRoom] = useState(false);
  const [room, setRoom] = useState('');

  const selectedRoom = (id) => setRoom(rooms[id]);

  const handleShowRoom = (id) => {
    selectedRoom(id);
    setIsVisibleRoom(true);
  };
  return !isVisibleRoom ? (
    <FarbRaume
      heading={heading}
      description={description}
      images={images}
      handleShowRoom={handleShowRoom}
    />
  ) : (
    <FarbRaum room={room} setIsVisibleRoom={setIsVisibleRoom} />
  );
};

FarbRaumePage.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.string,
  rooms: PropTypes.string,
};

export default connect(({ content }) => ({
  heading: R.path(['farbraum', 'heading'])(content),
  description: R.path(['farbraum', 'description'])(content),
  images: R.path(['farbraum', 'images'])(content),
  rooms: R.path(['farbraum', 'rooms'])(content),
}))(FarbRaumePage);
